import { AlertType } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/icon/Icon';

import * as S from './InlineAlert.styles';

interface InlineAlertProps {
  alertType: 'exceededLimit' | 'onlyOneSource';
}

export const InlineAlert = ({ alertType }: InlineAlertProps) => {
  const { t } = useTranslation(['chat']);

  return (
    <S.StyledAlert
      type={AlertType.Info}
      variant="inline"
      message={
        alertType === 'exceededLimit'
          ? t('chat:trustedSources.modal.exceededLimit')
          : t('chat:trustedSources.modal.onlyOneSource')
      }
      customIcon={
        <Icon
          fillColor="var(--icon-primary)"
          iconName="InformationCircle"
          size={20}
        />
      }
    />
  );
};
